import React from 'react';
import "../Style/Footer.css";

function Footer() {
    return (
        <div className="footer ">
            Copyright © 2026 Sovorir IT || All Rights Reserved
        </div>
    );
}

export default Footer;
